export enum Tab {
  Datasources = 'Datasources',
  SportsmanStatScales = 'Sportsman Stat Scales',
  TeamStatScales = 'Team Stat Scales',
  Sports = 'Sports',
  Tournaments = 'Tournaments',
  TournamentDatasourceIdentifiers = 'Datasource-ids',
  TournamentStageDatasourceIdentifiers = 'TDatasource-ids',
  Stages = 'Stages',
  Rounds = 'Rounds',
  Matches = 'Matches',
  MatchDatasourceIdentifiers = `Datasource-ids`,
  MatchMaps = 'Match Maps',
  MatchMapVetos = 'Match Map Vetos',
  Teams = 'Teams',
  Players = 'Players',
  Sportsmen = 'Sportsmen',
  Ranks = 'Ranks',
  Statistics = 'Statistics',
  Timespaces = 'Timespaces',
  TeamStats = 'Team Stats',
  TeamOrganizations = 'Team Organizations',
  SportsmanDatasourceIdentifiers = 'Datasource-ids',
  SportsmanStats = 'Sportsman Stats',
  SportsmanRanks = 'Sportsman Ranks',
  SportsmanTeamMemberships = 'Sportsman Team Memberships',
  SportsmanBiographies = 'Sportsman Biographies',
  TeamRanks = 'Team Ranks',
  TeamDatasourceIdentifiers = 'Datasource-ids',
  TeamOrganizatonDatasourceIdentifiers = 'Datasource-ids',
  TeamBiographies = 'Team Biographies',
  GammingGears = 'Gaming Gears',
  SportsmanGamingGears = 'Sportsman Gaming Gears',
  NearestMatches = 'Nearest Matches'
}
